
export default function ParaPais() {
  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          {/* Main Card */}
          <div className="relative bg-dark-800/90 backdrop-blur-xl border border-neon-purple/50 rounded-2xl md:rounded-3xl p-6 md:p-10 lg:p-12 shadow-[0_0_60px_rgba(139,92,246,0.4)]">
            {/* Header */}
            <div className="flex items-start justify-between mb-8">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-pink-500/20 border border-pink-500/30">
                <i className="ri-heart-fill text-pink-500 text-sm"></i>
                <span className="text-pink-500 text-xs font-semibold tracking-wider">MENSAGEM PARA OS PAIS</span>
              </div>
              <div className="w-10 h-10 bg-neon-purple/20 rounded-lg flex items-center justify-center">
                <i className="ri-group-fill text-neon-purple text-lg"></i>
              </div>
            </div>

            {/* Title */}
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white leading-tight mb-8 text-left">
              O Futuro do Seu Filho Começa Com a
              <span className="inline bg-gradient-to-r from-neon-purple to-pink-500 bg-clip-text text-transparent ml-2">
                Decisão Certa Hoje
              </span>
            </h2>

            {/* Content */}
            <div className="space-y-6 text-gray-300 leading-relaxed">
              <p className="text-base md:text-lg">
                Como pai ou mãe, você quer o melhor para seu filho. Você quer que ele tenha <strong className="text-white">oportunidades</strong>, que ele esteja <strong className="text-white">preparado</strong>, que ele tenha <strong className="text-white">vantagem</strong> no mundo competitivo de amanhã.
              </p>
              
              <p className="text-base md:text-lg">
                Mas a verdade é que <span className="text-pink-500">o sistema educacional tradicional não está preparando as crianças para o futuro.</span> Está preparando para um mundo que não existe mais.
              </p>

              <p className="text-base md:text-lg">
                A Inteligência Artificial já está transformando todas as profissões. As crianças que dominarem essas ferramentas <strong className="text-white">agora</strong> terão uma vantagem imensurável sobre as que esperarem.
              </p>
            </div>

            {/* Highlighted Box */}
            <div className="mt-8 p-6 bg-dark-800/60 border border-gray-600/50 rounded-xl">
              <p className="text-white text-base md:text-lg mb-2">
                <span className="text-yellow-400 mr-2">💡</span>
                A pergunta não é "se" seu filho vai aprender IA...
              </p>
              <p className="text-lg md:text-xl font-bold">
                A pergunta é: <span className="bg-gradient-to-r from-neon-purple to-pink-500 bg-clip-text text-transparent">ele vai aprender agora e sair na frente, ou vai aprender depois e ficar para trás?</span>
              </p>
            </div>

            {/* Description */}
            <div className="mt-8 space-y-4 text-gray-300">
              <p className="text-base md:text-lg">
                O <strong className="text-white">Freedom Experience</strong> não é apenas um curso. É um <strong className="text-white">investimento no futuro do seu filho.</strong> É dar a ele as ferramentas, o conhecimento e a mentalidade para não apenas sobreviver, mas <span className="text-neon-purple underline">liderar</span> no mundo de amanhã.
              </p>
            </div>

            {/* Quote */}
            <div className="mt-8 pl-4 border-l-4 border-neon-purple">
              <p className="text-white italic text-base md:text-lg font-medium">
                "O ambiente certo pode transformar uma criança comum em um gênio. O ambiente errado pode desperdiçar todo o potencial."
              </p>
              <p className="text-gray-400 text-sm mt-2">— Equipe IA KIDS</p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 mt-10">
              <div className="bg-dark-800/60 border border-gray-600/50 rounded-xl p-4 md:p-6 text-center">
                <p className="text-3xl md:text-4xl font-black bg-gradient-to-r from-neon-purple to-pink-500 bg-clip-text text-transparent">98%</p>
                <p className="text-gray-400 text-xs md:text-sm mt-1">Pais satisfeitos</p>
              </div>
              <div className="bg-dark-800/60 border border-gray-600/50 rounded-xl p-4 md:p-6 text-center">
                <p className="text-3xl md:text-4xl font-black text-neon-blue">+500</p>
                <p className="text-gray-400 text-xs md:text-sm mt-1">Crianças transformadas</p>
              </div>
              <div className="bg-dark-800/60 border border-gray-600/50 rounded-xl p-4 md:p-6 text-center">
                <p className="text-3xl md:text-4xl font-black text-pink-500">
                  4.9<i className="ri-star-fill text-xl md:text-2xl ml-1"></i>
                </p>
                <p className="text-gray-400 text-xs md:text-sm mt-1">Avaliação média</p>
              </div>
            </div>
          </div>

          {/* Image Section */}
          <div className="relative mt-12 max-w-sm mx-auto">
            <div className="relative rounded-2xl md:rounded-3xl overflow-hidden border border-neon-blue/30 shadow-[0_0_40px_rgba(0,212,255,0.3)]">
              <img 
                src="https://readdy.ai/api/search-image?query=proud%20parents%20watching%20their%20child%20succeed%20with%20holographic%20success%20symbols%20and%20achievement%20visualization%20showing%20family%20happiness%20and%20parental%20pride%20with%20blue%20neon%20lighting%20in%20modern%20inspiring%20environment%20representing%20child%20development%20and%20family%20support%20for%20future%20success&width=600&height=400&seq=parents&orientation=landscape"
                alt="Pais orgulhosos do sucesso dos filhos"
                className="w-full h-auto object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-neon-blue/20 via-transparent to-neon-purple/20"></div>
            </div>

            {/* Floating Card */}
            <div className="absolute -bottom-4 md:-bottom-6 -right-4 md:-right-6 bg-dark-800/90 backdrop-blur-xl border border-neon-blue/40 rounded-xl md:rounded-2xl p-3 md:p-4 shadow-[0_0_30px_rgba(0,212,255,0.4)] max-w-[160px] md:max-w-[200px]">
              <div className="flex items-center gap-2 md:gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-neon-blue to-neon-purple rounded-lg md:rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-trophy-fill text-xl md:text-2xl text-white"></i>
                </div>
                <div>
                  <p className="text-white font-bold text-xs md:text-sm">Sucesso</p>
                  <p className="text-neon-blue font-semibold text-xs">Garantido</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
